import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { eThemeMetronicComponents } from '../../enums/components';
import { LayoutStateService } from '../../services/layout-state.service';
import { LayoutService } from '../../services/layout.service';

@Component({
	selector: 'hedou-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.less']
})
export class SidebarComponent implements OnInit {


	@Input()
	isMenuExpanded: boolean;
	@Input()
	smallScreen: boolean;
	@Input()
	isMenuPlacementTop: boolean;

	@Output()
	mouseMoveContainer = new EventEmitter<Array<ElementRef<HTMLElement>>>();

	@ViewChild('navbarSidebar', { read: ElementRef })
	navbarSidebarRef: ElementRef<HTMLElement>;

	disableAsideSelfDisplay: boolean;
	headerLogo: string;
	brandSkin: string;
	ulCSSClasses: string;
	location: Location;
	asideMenuHTMLAttributes: any = {};
	asideMenuCSSClasses: string;
	asideMenuDropdown;
	brandClasses: string;
	asideMenuScroll = 1;
	asideSelfMinimizeToggle = false;

	routesComponentKey = eThemeMetronicComponents.Routes;

	isSidebarCollapsed$ = this.layoutStateService.get$('isSidebarCollapsed');
	mouseOnSidebar$ = this.layoutStateService.get$('mouseOnSidebar');

	constructor(
		private layout: LayoutService,
		private layoutStateService: LayoutStateService) {

	}


	onClickLink() {
		if (this.smallScreen) {
			//this.layoutStateService.patch({ isMenuExpanded: false, isNavbarExpanded: false });
		}
	}

	onClickMenuIcon(isSidebarCollapsed: boolean) {
		this.layout.onClickMenuIcon(isSidebarCollapsed);
	}

	onMouseover(mouseOnSidebar: boolean) {
		// console.log(mouseOnSidebar)
		this.layout.onMouseOverSidebar(mouseOnSidebar);
	}

	ngOnInit(): void {
		this.disableAsideSelfDisplay = this.layout.getProp('aside.self.display') === false;
		this.brandSkin = this.layout.getProp('brand.self.theme');
		this.headerLogo = this.getLogo();
		this.ulCSSClasses = this.layout.getProp('aside_menu_nav');
		this.asideMenuCSSClasses = this.layout.getStringCSSClasses('aside_menu');
		this.asideMenuHTMLAttributes = this.layout.getHTMLAttributes('aside_menu');
		this.asideMenuDropdown = this.layout.getProp('aside.menu.dropdown') ? '1' : '0';
		this.brandClasses = this.layout.getProp('brand.self.theme');
		this.asideSelfMinimizeToggle = this.layout.getProp(
			'aside.self.minimize.toggle'
		);
		this.asideMenuScroll = this.layout.getProp('aside.menu.scroll') ? 1 : 0;
	}

	private getLogo() {
		if (this.brandSkin === 'light') {
			return './assets/media/logos/logo-dark.png';
		} else {
			return './assets/media/logos/logo-light.png';
		}
	}

}
